const signUpPageTranslations = {
  intro: {
    title: "مرحبًا بك!",
    subtitle: "أهلاً بك في أول تجربة تدريبية فريدة من نوعها عبر الإنترنت.",
    signInText: "لديك حساب بالفعل؟",
    signInLink: "تسجيل الدخول",
  },
  heroSection: {
    brandingText: "تجربة تدريبية حصرية وفريدة من نوعها",
    hookText:
      "أنت على بعد خطوة واحدة من التجربة الحصرية التي لطالما استحقيتها.",
  },
  form: {
    subscriptionId: "رقم الاشتراك",
    firstName: "الاسم الأول",
    lastName: "الاسم الأخير",
    email: "البريد الإلكتروني",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    male: "ذكر",
    female: "أنثى",
    action: "إنشاء حساب",
  },
};

export default signUpPageTranslations;
